import Modal from "./Modal";

import LocationAssignment from "../ui/LocationAssignment";

const LocationAssignmentModal = ({ locations, open, onClose, onAssigned }) => {
  return (
    <Modal
      title="Location Assignemnt"
      open={open}
      onClose={onClose}
    >
      <LocationAssignment
        locations={locations}
        onClose={onclose}
        onAssigned={onAssigned}
      />
    </Modal>
  );
};

export default LocationAssignmentModal;
